import { ButtonV2, Input } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../../../components/toast/Toast';
import { useFirmContext } from '../../../../../providers/FirmProvider';
import { useCreateAtosaConfig } from '../../../../../queries/use-create-atosa-config';

function FirmAtosaIntegration(): JSX.Element {
    const { integrations } = useFirmContext();
    const atosa = integrations.atosa;

    const [replacing, setReplacing] = useState(false);
    const [key, setKey] = useState<string>();

    const { mutate, isLoading } = useCreateAtosaConfig();

    function handleSave(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();

        if (!key || key.length === 0) {
            return;
        }

        mutate(
            { apiKey: key.trim() },
            {
                onError: (err) => {
                    toastNotification('error', err.response?.data?.message ?? 'Something went wrong');
                },
                onSuccess: () => {
                    toastNotification('success', 'Successfully connected to Atosa!');
                    setReplacing(false);
                    setKey(undefined);
                },
            }
        );
    }

    if (atosa && !replacing) {
        return (
            <div className="mb-4">
                <p className="text-sm font-bold text-gray-800">Replace or delete your Atosa API Key</p>
                <p className="text-sm text-gray-600 mt-1">aak_cimpl_***************</p>
                <div className="flex items-center gap-2 mt-4">
                    <ButtonV2 size="sm" type="secondary" label="Replace Key" onClick={(): void => setReplacing(true)} />
                    <ButtonV2 size="sm" type="danger" label="Remove Key" disabledHint={'Coming soon'} isDisabled />
                </div>
            </div>
        );
    }

    return (
        <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">
                Please enter your Atosa API key for the <b>Cimplico</b> integration. View setup instructions{' '}
                <a href="https://support.cimplico.com" className="text-indigo-600">
                    here
                </a>
            </p>
            <form onSubmit={handleSave}>
                <Input
                    placeholder="aak_cimpl_xxxxxxxxxxxxxxx"
                    label="API Key"
                    type="text"
                    name="apiKey"
                    value={key}
                    onChange={(e): void => setKey(e.target.value)}
                    disabled={isLoading}
                    autoFocus
                />
                <div className="mt-2 ml-auto w-fit gap-2 flex items-center">
                    {replacing && (
                        <ButtonV2
                            type="secondary"
                            size="sm"
                            label="Cancel"
                            onClick={(): void => {
                                setReplacing(false);
                                setKey(undefined);
                            }}
                        />
                    )}
                    <ButtonV2 size="sm" label="Save" isSubmit isDisabled={isLoading} isLoading={isLoading} />
                </div>
            </form>
        </div>
    );
}

export default FirmAtosaIntegration;
